const errorFlagNames = {

    TF: {
        title: 'Test failed',
        0: 'DTC is not present at the time of the request',
        1: 'DTC is present at the time of the request'
    },

    TFTOC: {
        title: 'Test failed this monitoring cycle',
        0: 'DTC is not active on the current operation cycle',
        1: 'DTC was active on the current operation cycle'
    },

    PDTC: {
        title: 'Pending DTC',
        0: 'DTC is not active on the current or previous operation cycle',
        1: 'DTC is active on the current or previous operation cycle',
    },

    CDTC: {
        title: 'Confirmed DTC',
        0: 'DTC not confirmed',
        1: 'DTC confirmed'
    },

    TNCSLS: {
        title: 'Test not completed since last clear',
        0: 'DTC test was completed since the last code clear',
        1: 'DTC test is not completed since the last code clear'
    },

    TFSLC: {
        title: 'Test failed since last clear',
        0: 'DTC was not active since last code clear',
        1: 'DTC was active minimal once since last code clear'
    },

    TNCTOS: {
        title: 'Test not completed this monitoring cycle',
        0: 'DTC test is completed during this operation cycle',
        1: 'DTC test is not completed during this operation cycle'
    },

    WIR: {
        title: 'Warning indicator requested',
        0: 'Warning indicator is not active',
        1: 'Warning indicator is active'
    }
}

export default errorFlagNames
